<template src="./companychecktemplates.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";

  export default {
    components: {},
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "--";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
      showstring: function (data) {
        if (data == "" || data == null) {
          return "";
        } else {
          return data.replaceAll("_", " ");
        }
      },
    },
    data() {
      return {
      	ClassId: 0,
        ShowLoader: false,
        ShowTemplateAddModel: false,
        ClassData: {},
        CompanyCheckTemplates: [],
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        SearchForm: {
          Name: "",
        },
        SubmitTemplate: {},
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Settings";
      this.ClassId = this.$route.params.ClassId;
      this.GetCompanySubscription();
    },
    methods: {
      GetTemplatesList(type = "") {
        var obj = { token: localStorage.getItem("token"),ClassId:this.ClassId };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleCheckTemplate.Template.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.ShowLoader = false;
            this.CompanyCheckTemplates = Response.data.Templates;
            this.ClassData = Response.data.ClassData;
          }
        });
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isAssets = FleetSubscriptionModules.Assets;
        if (isAssets) {
          this.GetTemplatesList();
        } else {
          this.$router.push("/settings");
        }
      },
      DeleteTemplate(tempId) {
        this.$swal({
          title: "Are you sure You want to delete this Template?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#514b71",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal({
              title: "Deleting...",
              text: "Please wait...",
              imageUrl: require("@/assets/images/LoadingTwo.gif"),
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.VehicleCheckTemplate.Template.Delete, {
              token: localStorage.getItem("token"),
              id: tempId,
            }).then((Response) => {
              this.$swal(
                "Template Record Deleted Successfully",
                "",
                "success"
              ).then(() => {
                this.GetTemplatesList();
              });
            });
          }
        });
      },
      EditTemplate(Template) {
        this.ShowTemplateAddModel = true;
        this.SubmitTemplate.class_name = Template.class_name;        
        this.SubmitTemplate.name = Template.name;
        this.SubmitTemplate.id = Template.id;
      },
      EditTemplateSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitTemplate.name) {
          error = true;
          errorStr += "Please Enter Template Name";
        }

        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Editing Template...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.VehicleCheckTemplate.Template.Update, {
            token: localStorage.getItem("token"),
            id: this.SubmitTemplate.id,
            name: this.SubmitTemplate.name,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              this.ShowTemplateAddModel = false;
              this.GetTemplatesList();
              this.$swal("Template Updated Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
    },
    
    
  };
</script>

<style type="text/css"></style>
